

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from '../assets/logo.png';
import axios from "axios";
function Login() {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

const handleSubmit = (e) => {
  e.preventDefault();

  const body = {
    username: userId,
    password: password
  };

  axios
    .post("https://ims-attendanceback.indevconsultancy.in/api/login/", body)
    .then((res) => {

      const user = res.data.user; // ✅ correct

      // Save in localStorage
      localStorage.setItem("user_id", user.userid);
      localStorage.setItem("role_id", user.roleid);
      localStorage.setItem("username", user.username);

      console.log("Login successful");
      console.log("User ID:", user.userid);
      console.log("Username:", user.username);
      console.log("Role ID:", user.roleid);

      // 🔀 Role-based navigation
      if (user.roleid == '1') {
        navigate("/kitchen");
      } else if (user.roleid == '2' || user.roleid == '3') {
        navigate("/admindashboard");
      }

    })
    .catch((error) => {
      console.error("Login failed:", error);
      setError("Invalid email or password");
    });
};


  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-cream">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-sm-10 col-md-6 col-lg-5 col-xl-4">
            <div className="card shadow">
              <div className="card-header text-center text-white">
                <img src={logo} alt="एकता फाउंडेशन लोगो" />
              </div>

              <div className="card-body px-4 py-5">
                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label htmlFor="userId" className="form-label fw-semibold">
                      उपयोगकर्ता आईडी
                    </label>
                    <input
                      id="userId"
                      className="form-control"
                      type="text"
                      // placeholder="यूज़र आईडी दर्ज करें"
                      value={userId}
                      onChange={(e) => setUserId(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-4">
                    <label htmlFor="password" className="form-label fw-semibold">
                      पासवर्ड
                    </label>
                    <input
                      id="password"
                      className="form-control"
                      type="password"
                      // placeholder="पासवर्ड दर्ज करें"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>

                  {error && (
                    <div className="alert alert-danger py-2">{error}</div>
                  )}

                  <div className="d-grid">
                    <button className="btn btn-primary" type="submit">
                      साइन इन करें
                    </button>
                  </div>
                </form>
              </div>

              <div className="card-footer text-center text-muted login-footer">
                तकनीकी साझेदार: Indev Consultancy
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
